module.exports = __webpack_public_path__ + "static/media/gray_animal_insects_6.15798b29.png";